import { render, staticRenderFns } from "./BookDetail.vue?vue&type=template&id=6080307c&scoped=true&"
import script from "./BookDetail.vue?vue&type=script&lang=js&"
export * from "./BookDetail.vue?vue&type=script&lang=js&"
import style0 from "./BookDetail.vue?vue&type=style&index=0&id=6080307c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6080307c",
  null
  
)

export default component.exports